// generated by @tcg/api-client gen-client — do not edit
import type { paths } from "./schema";
import { createServiceClient, type ServiceClientOptions } from "../../create-client";

export type ConsignmentPaths = paths;
export const CONSIGNMENT_SERVICE = "consignment" as const;

/** Typed openapi-fetch client for the consignment service (schema `consignment`). */
export function createConsignmentClient(options: ServiceClientOptions) {
  return createServiceClient<paths>("consignment", options);
}

export type ConsignmentClient = ReturnType<typeof createConsignmentClient>;
